import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { addStorageTableForm, deleteStorageTableFormDetails, updateStorageForm, updateStorageTableForm } from '../../../../services/configurationServices';
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';
import Swal from 'sweetalert2';

let fps = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

const StorageConfigItem = ({ data, selectedStorage, transcodingList, count, setCount, recordingTypeList, RecordingServerTypeID, recordingServerType }) => {
    const { DeviceName, DeviceID, RTSPCameraUrl, EnableRecording, Status, InPutURL, RecordingRetentionPeriod, RecordingLength, IsTranscodingEnable, TranscodingConfig, FPS, DeviceRecordingConfigID, RecordingTypeID, ScheduleId, FromDateTime, ToDateTime } = data


    const [encoding, setEncoding] = useState(IsTranscodingEnable);
    const [recording, setRecording] = useState(EnableRecording);
    const [isChecked, setIsChecked] = useState(Status);
    const [transcodingSelected, setTranscodingSelected] = useState("")
    const [fpsSelected, setFpsSelected] = useState(FPS)
    const [isEdit, setIsEdit] = useState(false);
    const [selectedTranscoding, setSelectedTranscoding] = useState(TranscodingConfig)
    const [storeRecording, setStoreRecording] = useState(RecordingRetentionPeriod)
    const [recordingLength, setRecordingLength] = useState(RecordingLength)
    const [selectedRecordingType, setSelectedRecordingType] = useState(RecordingTypeID)
    const [show, setShow] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedInputUrl, setSelectedInputUrl] = useState(InPutURL)
    const [buttonDisable, setButtonDisable] = useState(false)

    const [fromTimeModal, setFromTimeModal] = useState(FromDateTime)
    const [toTimeModal, setToTimeModal] = useState(ToDateTime)
    const [fromTimeModalError, setFromTimeModalError] = useState("")
    const [toTimeModalError, setToTimeModalError] = useState("")

    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);
        setSelectedRecordingType(value)
        let timeBase = recordingTypeList?.find(i => i.RecordingType == "Time Based")
        let scheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
        if (value == timeBase?.RecordingTypeId || value == scheduleBase?.RecordingTypeId) {
            setShow(true);
        }
    };
    console.log("FPS", recordingServerType)
    const onSetModal = () => {
        let isValidate = false
        if (fromTimeModal == "" || fromTimeModal == 0) {
            setFromTimeModalError("please enter a  FromTime")
            isValidate = true;
        }
        if (toTimeModal == "" || toTimeModal == 0) {
            setToTimeModalError("please enter a Totime!")
            isValidate = true;
        }

        if (isValidate) {
            return;
        } else {
            hideModel()
        }
    }
    const hideModel = () => {
        setShow(false);
    }
    console.log("selectedStorage", selectedStorage)

    const resetForm = () => {
        setEncoding(false)
        setRecording(false)
        setIsChecked(false)
        setFpsSelected(0)
        // setIsEdit(false)
        setSelectedTranscoding("")
        setStoreRecording(0)
        setRecordingLength("")
        setSelectedRecordingType(0)
        setSelectedInputUrl(InPutURL)
    }

    const onCancelStorageConfig = (e) => {
        e.stopPropagation();
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to cancel the changes made?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Leave!"
        }).then((result) => {
            if (result.isConfirmed) {
                setIsChecked(Status)
                setEncoding(IsTranscodingEnable)
                setRecording(EnableRecording)
                setFpsSelected(FPS)
                setSelectedTranscoding(TranscodingConfig)
                setStoreRecording(RecordingRetentionPeriod)
                setRecordingLength(RecordingLength)
                setSelectedInputUrl(InPutURL)
                setSelectedRecordingType(RecordingTypeID)
                setIsEdit(false)
            }
        })
    }
    const onSaveStoargeTable = async () => {
        // if (!isChecked) {
        //     ErrorToast("Please enable the device.")
        //     return;
        // }
        // if (selectedInputUrl =="" || selectedInputUrl == null){
        //     ErrorToast("Please enter a Input source url")
        //     return;
        // }
        // if (storeRecording == 0 || storeRecording == null || storeRecording == "") {
        //     ErrorToast("Please enter the number of days to store the recording.")
        //     return;
        // }
        //         if (storeRecording > 2) {
        //     ErrorToast("Maximum allowed storage is 2 days.");
        //     return;
        // }
        // if(recordingLength == 0 || recordingLength == null){
        //     ErrorToast("Please select recording length")
        //     return;
        // }
        // if (encoding) {
        //     if (selectedTranscoding == 0 || selectedTranscoding == null) {
        //         ErrorToast("Please select the transcoding type")
        //         return;
        //     }
        // }

        // if (encoding) {
        //     if (fpsSelected == 0 || fpsSelected == null) {
        //         ErrorToast("Please select FPS")
        //         return;
        //     }
        // }

        // if (selectedRecordingType == 0 || selectedRecordingType == null) {
        //     ErrorToast("Please select the recording type")
        //     return
        // }

        // if(selectedStorage == null){
        //     }
        let user = JSON.parse(localStorage.getItem("user"));
        if (DeviceRecordingConfigID == 0) {
            let addStorageTableObj = {
                OrganizationMasterID: user?.OrganizationMasterID.toString(),
                DeviceName: DeviceName,
                RecordingStoragePathID: selectedStorage?.RecordingStoragePathID,
                IsTranscodingEnable: encoding,
                TranscodingConfig: selectedTranscoding,
                IsEncodingEnable: false,
                EncodingConfig: null,
                RecordingLength: "00:03:00",//recordingLength
                RecordingRetentionPeriod: selectedStorage?.RecordingRetentionPeriod,
                EnableRecording: true,
                InPutURL: selectedInputUrl,
                OutPutURL: null,
                DeviceID: DeviceID,
                FPS: fpsSelected.toString(),
                RecordingTypeID: selectedStorage?.RecordingTypeID,
                FromDateTime: selectedStorage?.FromDateTime,
                ToDateTime: selectedStorage?.ToDateTime,
                ScheduleId: selectedStorage?.ScheduleId
                //RecordingTypeis missing
            }
            console.log("addStorageTableObj", addStorageTableObj)
            addStorageTableForm(addStorageTableObj).then((resp) => {
                if (resp.Status == "success") {
                    //getAPI Come here 
                    setCount((prevCount) => prevCount + 1)
                    SuccessToast(resp.Message)
                    setRecording(true)

                } else {
                    ErrorToast(resp.Message)
                }
            })
        } else {
            let updateStorageTableObj = {
                DeviceRecordingConfigID: DeviceRecordingConfigID,
                OrganizationMasterID: user?.OrganizationMasterID.toString(),
                DeviceName: DeviceName,
                RecordingStoragePathID: selectedStorage?.RecordingStoragePathID,
                IsTranscodingEnable: encoding,
                TranscodingConfig: selectedTranscoding,
                IsEncodingEnable: false,
                EncodingConfig: null,
                RecordingLength: "00:03:00",
                RecordingRetentionPeriod: selectedStorage?.RecordingRetentionPeriod,
                EnableRecording: !recording,
                InPutURL: selectedInputUrl,
                OutPutURL: null,
                DeviceID: DeviceID,
                FPS: fpsSelected.toString(),
                RecordingTypeID: selectedStorage?.RecordingTypeID,
                FromDateTime: selectedStorage?.FromDateTime,
                ToDateTime: selectedStorage?.ToDateTime,
                ScheduleId: selectedStorage?.ScheduleId
            }
            updateStorageTableForm(updateStorageTableObj).then((resp) => {
                if (resp.Status == "success") {
                    //getAPI Come here 
                    setCount((prevCount) => prevCount + 1)
                    setIsEdit(false)
                    SuccessToast(resp.Message)
                } else {
                    ErrorToast(resp.Message)
                }
            })

        }
    }
    const deleteStorageFormTableView = () => {
        setButtonDisable(true);
        try {
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to remove Configurable Video Backup device!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#027aaa",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Remove it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    // let obj = {
                    //     RecordingStorageID:selectedRecording.RecordingStorageID
                    // }
                    //change this selectedStorage?.RecordingStoragePathID
                    deleteStorageTableFormDetails(DeviceRecordingConfigID).then((res) => {
                        if (res.Status == "success") {
                            setCount((prevCount) => prevCount + 1)
                            setButtonDisable(false);
                            SuccessToast(res.Message);
                            //getStorageListForm(item?.RecordingStorageID);
                            //getAPI calling 
                            resetForm()
                            // setSelectedStorage(null)
                        }
                    })
                        .catch((err) => console.log(err));
                } else {
                    setButtonDisable(false);
                    // setNotifDeleteBtnClicked(false);
                }
            });
        } catch (error) {
            console.log(error);
            setButtonDisable(false);
        }
    }
    console.log("RecordingServerTypeID", RecordingServerTypeID)
    return (
        <tr>
            {/* <td style={{ minWidth: "50px", width: "4%", textAlign: "center" }}>
                <input
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    type='checkbox'
                    disabled={!isEdit && DeviceRecordingConfigID != 0}
                //disabled={isEdit}
                />
            </td> */}
            <td style={{ textAlign: "center" }}>
                {
                    !isEdit && DeviceRecordingConfigID == 0
                    &&
                    <button className="DataAccessEdit" style={{ width: "65px" }} onClick={onSaveStoargeTable}>
                        <span className="ViewUpdate">Add</span>
                    </button>
                }
                {
                    DeviceRecordingConfigID != 0
                    &&
                    <button className="DataAccessEdit" style={{ width: "68px" }} onClick={deleteStorageFormTableView}>
                        <span className="ViewUpdate">Remove</span>
                    </button>
                }

            </td>
            <td style={{ textAlign: "center" }}>
                <div className='togglecheckbox'>
                    <label>
                        <input
                            type="checkbox"
                            checked={recording}
                            disabled={DeviceRecordingConfigID == 0}
                            onChange={() => {
                                setRecording(!recording)
                                if (DeviceRecordingConfigID != 0) {
                                    onSaveStoargeTable();
                                }
                            }}
                        />
                        <span />
                    </label>
                </div>
            </td>
            <td>{DeviceID}</td>
            <td className='DeviceNameTrucateText'>{DeviceName}</td>


            {/* <td>
                <div className={'inputTypeLabelContainer'}>
                    <input className="inputType"
                        placeholder="Enter stream address here"
                        style={{ fontSize: "14px" }}
                        value={selectedInputUrl}
                        disabled={true}
                        title={selectedInputUrl}
                    />
                </div>
            </td> */}
            {/* <td>
                <div className={'inputTypeLabelContainer'}>
                    <input className="inputType"
                        type='number'
                        placeholder="Number of days"
                        style={{ fontSize: "14px" }}
                        value={storeRecording}
                        disabled={!isEdit && DeviceRecordingConfigID != 0}
                        onChange={(e) => {
                            setStoreRecording(e.target.value)

                        }}
                    />
                </div>
            </td> */}
            {/* <td>
                <div className={'inputTypeLabelContainer'}>
                    <input className="inputType"
                        type='time'
                        step={2}
                        // type="text"
                        // placeholder="MM:SS"
                        // pattern="([0-5]?[0-9]):([0-5]?[0-9])"
                         style={{ fontSize: "14px" }}
                         value={recordingLength}
                         disabled={!isEdit && DeviceRecordingConfigID != 0}
                         onChange={(e) => {
                             setRecordingLength(e.target.value)
                             
       }}   
                    />
                </div>
            </td> */}
            {/* <td style={{textAlign: "center"}}>
                <div className='togglecheckbox'>
                    <label>
                        <input
                            type="checkbox"
                            checked={encoding}
                            disabled={!isEdit && DeviceRecordingConfigID != 0}
                            onChange={() => setEncoding(!encoding)}
                        />
                        <span />
                    </label>
                </div>
            </td> */}
            {/* <td>
                <div className={'inputTypeLabelContainer'}>
                    <select className="inputType ArrowSelectClass"
                    style={{cursor: ((!isEdit && DeviceRecordingConfigID != 0) || !encoding)   && 'not-allowed'}}
                    value={selectedTranscoding}
                    disabled={(!isEdit && DeviceRecordingConfigID != 0) || !encoding}
                    onChange={(e) => {
                        setSelectedTranscoding(e.target.value)
                      }}
                    >
                        <option key="0" disabled={false} value="0" id="0">Select</option>

                        {transcodingList &&
                                                transcodingList.map((val) => (
                                                  <option value={val.TranscodingTypeDetailsID} key={val.TranscodingTypeDetailsID} id={val.TranscodingTypeDetailsID}>
                                                    {val.TranscodingTypeDetail}
                                                  </option>
                                                ))} 
                                        
                    </select>
                </div>
            </td> */}
            {/* <td>
                <div className={'inputTypeLabelContainer'}>
                    <select className="inputType ArrowSelectClass" 
                    style={{cursor:((!isEdit && DeviceRecordingConfigID != 0) || !encoding)  && 'not-allowed'}}
                    value={fpsSelected} 
                    disabled={(!isEdit && DeviceRecordingConfigID != 0) || !encoding}
                     onChange={(e) => setFpsSelected(e.target.value)}>
                        <option value={0}>Select FPS</option>
                        {
                            fps.map((item) => (
                                <option value={item} key={item}>{item}</option>
                            ))
                        }
                    </select>
                </div>
            </td> */}
            {/* {
                recordingServerType?.find(i => i.RecordingServerType == "Real Time")?.RecordingServerTypeID == RecordingServerTypeID
                    ?
                    <td style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div className={'inputTypeLabelContainer'} style={{ width: "100%" }}>
                            <select className="inputType ArrowSelectClass"
                                value={selectedRecordingType}
                                disabled={!isEdit && DeviceRecordingConfigID != 0}
                                onChange={handleChange}
                            >
                                <option key="0" value="0">Select Recording Type</option>
                                {
                                    recordingTypeList &&
                                    recordingTypeList
                                        .filter(i => i.RecordingType !== "Scheduled")
                                        .map((val) => (
                                            <option value={val.RecordingTypeId} key={val.RecordingTypeId} id={val.RecordingTypeId}>
                                                {val.RecordingType}
                                            </option>
                                        ))
                                }
                                
                            </select>
                        </div>
                        {
                            recordingTypeList?.find(i => i.RecordingType == "Time Based")?.RecordingTypeId == selectedRecordingType &&
                            <p className='m-0'>From-{fromTimeModal} To-{toTimeModal}</p>
                        }
                    </td>
                    :
                    <td style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div className={'inputTypeLabelContainer'} style={{ width: "100%" }}>
                            <select className="inputType ArrowSelectClass"
                                value={selectedRecordingType}
                                disabled={!isEdit && DeviceRecordingConfigID != 0}
                                onChange={handleChange}
                            >
                                <option key="0" value="0">Select Recording Type</option>
                                {
                                    recordingTypeList &&
                                    recordingTypeList
                                        .filter(i => i.RecordingType === "Scheduled")
                                        .map((val) => (
                                            <option value={val.RecordingTypeId} key={val.RecordingTypeId} id={val.RecordingTypeId}>
                                                {val.RecordingType}
                                            </option>
                                        ))
                                }
                            </select>
                        </div>
                        {
                            // 10 == 10
                            recordingTypeList?.find(i => i.RecordingType == "Scheduled")?.RecordingTypeId == selectedRecordingType &&
                            <p className='m-0'>From-{fromTimeModal}</p>
                            // <p className='m-0'>From-{fromTimeModal} To-{toTimeModal}</p>
                        }
                    </td>

            } */}



            {/* <td>
                {
                    !isEdit
                    &&

                    <button className="DataAccessEdit" style={{ width: "65px" }} disabled={!(!isEdit && DeviceRecordingConfigID != 0)} onClick={() => setIsEdit(true)}>
                        <span className="ViewUpdate">Edit</span>
                    </button>
                }
                {
                    isEdit
                    &&
                    <button className="DataAccessEdit" style={{ width: "65px" }} onClick={onSaveStoargeTable}>
                        <span className="ViewUpdate">Update</span>
                    </button>
                }
                {
                    isEdit
                    &&
                    <button className="DataAccessEdit" style={{ width: "65px" }} onClick={resetForm}>
                        <span className="ViewUpdate">Reset</span>
                    </button>
                }
                {
                    isEdit && DeviceRecordingConfigID != 0
                    &&
                    <button className="DataAccessEdit" style={{ width: "65px" }} onClick={onCancelStorageConfig}>
                        <span className="ViewUpdate">Cancel</span>
                    </button>
                }

            </td> */}

            {
                recordingServerType?.find(i => i.RecordingServerType == "Real Time")?.RecordingServerTypeID == RecordingServerTypeID

                    ?
                    <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-50w" backdrop="static" className="AddCustomerModal">
                        <>
                            <Modal.Header >
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {DeviceName}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div style={{ display: "flex" }}>
                                    <div className="inputMainContainer w40dot75rem mr-1">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>From Time</label>
                                            <input
                                                type="time"
                                                step={2}
                                                className="inputType"
                                                placeholder="Ex. 09:00:00 AM"
                                                value={fromTimeModal}
                                                onChange={(e) => {
                                                    setFromTimeModal(e.target.value)
                                                    setFromTimeModalError('')
                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span>{fromTimeModalError}</span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem ml-1">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>To Time</label>
                                            <input
                                                type="time"
                                                step={2}
                                                className="inputType"
                                                placeholder="Ex. 09:00:00 PM"
                                                value={toTimeModal}
                                                onChange={(e) => {
                                                    setToTimeModal(e.target.value)
                                                    setToTimeModalError('')
                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span>{toTimeModalError}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ textAlign: "center" }}>
                                    <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={onSetModal}>
                                        <span className="ViewUpdate">Set</span>
                                    </button>
                                    <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={hideModel}>
                                        <span className="ViewUpdate">Cancel</span>
                                    </button>
                                </div>
                            </Modal.Body>
                        </>
                    </Modal>
                    :
                    <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-50w" backdrop="static" className="AddCustomerModal">
                        <>
                            <Modal.Header >
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {DeviceName}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div style={{ display: "flex" }}>
                                    <div className="inputMainContainer w40dot75rem mr-1">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>From Time</label>
                                            <input
                                                type="time"
                                                step={2}
                                                className="inputType"
                                                placeholder="Ex. 09:00:00 AM"
                                                value={fromTimeModal}
                                                onChange={(e) => {
                                                    setFromTimeModal(e.target.value)
                                                    setFromTimeModalError('')
                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span>{fromTimeModalError}</span></p>
                                        </div>
                                    </div>

                                    {/* <div className="inputMainContainer w40dot75rem ml-1">
                                <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>To Time</label>
                                    <input
                                    type="time"
                                    step={2}
                                    className="inputType"
                                    placeholder="Ex. 09:00:00 PM"
                                    value={toTimeModal}
                                    onChange={(e)=>{
                                        setToTimeModal(e.target.value)
                                        setToTimeModalError('')
                                    }}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span>{toTimeModalError}</span></p>
                                </div>
                            </div> */}
                                </div>
                                <div style={{ textAlign: "center" }}>
                                    <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={onSetModal}>
                                        <span className="ViewUpdate">Set</span>
                                    </button>
                                    <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={hideModel}>
                                        <span className="ViewUpdate">Cancel</span>
                                    </button>
                                </div>
                            </Modal.Body>
                        </>
                    </Modal>
            }

        </tr>
    )
}

export default StorageConfigItem
